const normalizedPackageName = (type: string) => (type === 'Plan' ? 'plan' : 'add-on');

export { normalizedPackageName };
